import { useEffect, useState } from 'react';
import { bookingApi } from '../services/bookingApi';

// Loads the Square Web Payments SDK script once, then exposes `payments`.
// Pulls config (sandbox vs production URL, app id, location id) from backend.
let scriptPromise = null;

const loadSquareScript = (url) => {
  if (window.Square) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = url;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Failed to load Square Web Payments SDK'));
    document.head.appendChild(s);
  });
  return scriptPromise;
};

export const useSquarePayments = () => {
  const [config, setConfig] = useState(null);
  const [payments, setPayments] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const cfg = await bookingApi.getConfig();
        if (cancelled) return;
        setConfig(cfg);
        await loadSquareScript(cfg.web_payments_sdk_url);
        if (cancelled) return;
        const p = window.Square.payments(cfg.application_id, cfg.location_id);
        setPayments(p);
      } catch (e) {
        if (!cancelled) setError(e.message || 'Failed to load payment system');
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { config, payments, error };
};
